<div [class]="darkModeBgColour" class="flex bg-white p-2 rounded" (click)="navigateIfFullClick()">

  <!-- Profile Picture -->
  <div class="flex flex-row items-center">
    @if (profilePicWithAlerts === false) {
      <app-profile-picture class="w-10 h-10" [fitMedProfileId]="fitMedProfileValue?.id"></app-profile-picture>
    } @else {
      <app-profile-picture-with-alerts
        class="w-10 h-10"
        [fitMedProfile]="fitMedProfileValue"
        [alertText]="amountOfAlerts"
        [alertColour]="alertColour"
      ></app-profile-picture-with-alerts>
    }

  </div>

  <div class="title text-black dark:text-white">

    <!-- Title -->
    @if (navigationEnabled) {
      <a class="hover:underline"
        [routerLink]="nameLink"
        [queryParams]="{ patientFitMedProfileId, practitionerId }"
      [innerHTML]="title ?? fullName"></a>
    }

    @if (!navigationEnabled) {
      <span [innerHTML]="title ?? fullName"></span>
    }

    <!-- SubTitle -->
    <div class="subtitle text-black dark:text-white">
      <div #ref>
        <ng-content select="[subtitle]"></ng-content>
      </div>

      <!-- default displaying of the subtitle -->
      @if (!ref.children.length) {
        <!-- gender && dob if no sub title -->
        @if (!subtitle) {
          <app-gender [fitMedProfile]="fitMedProfileValue" [name]="true" [icon]="true"></app-gender>
          <span>|</span>
          <span>{{ fitMedProfileValue?.doB | localizedDate: 'mediumDate' }}</span>
        }
        @if (subtitle) {
          <span [innerHTML]="subtitle"></span>
        }
      }
    </div>
  </div>
</div>
